import { useAuthStateStore, usePublicProgressStateStore, } from '@annunciate/core';
import { fetchRecentProgress } from './fetchRecentProgress';
import { resolveRemoteAndLocalSyncs } from './resolveRemoteAndLocalSyncs';
import { request } from '../request';
import { PROGRESS_UPSERT } from '../queries';
export const syncProgress = async (client) => {
    const uuid = useAuthStateStore.getState().getUUID(true);
    const progressKey = `progress`;
    let remoteProgress = await fetchRecentProgress(client);
    let updates = await resolveRemoteAndLocalSyncs(client, remoteProgress || []);
    const upserts = updates.remote.map(({ contentId, position }) => ({
        contentId,
        position,
    })).filter((upsert) => upsert.contentId >= 0);
    if (upserts.length > 0 && uuid !== 'public') {
        try {
            await request({
                query: PROGRESS_UPSERT,
                variables: { items: upserts },
            });
            remoteProgress = await fetchRecentProgress(client);
            updates = await resolveRemoteAndLocalSyncs(client, remoteProgress || []);
        }
        catch (err) {
            throw new Error('An unknown error occurred syncing progress. Please contact support.');
        }
    }
    else if (uuid === 'public') {
        const progress = [
            ...updates.remote,
            ...updates.local,
        ].filter(p => p.uuid === 'public');
        usePublicProgressStateStore.getState().setProgress(progress);
    }
    updates.local.forEach((item) => {
        const itemCacheKey = [progressKey, { contentId: item.contentId, uuid }];
        client.setQueryDefaults(itemCacheKey, {
            gcTime: Infinity,
            staleTime: Infinity,
        });
        item.updatedAt = new Date();
        client.setQueryData(itemCacheKey, item);
    });
};
//# sourceMappingURL=syncProgress.js.map